import { LitElement, html, css } from 'lit';
import { FetchMixin } from '../FetchMixin';
import pwappyPointStore from '../PwappyPointStore';
import { setPwappyPoints } from '../PwappyPointSlice';
import alertStore from '../AlertStore.js';
import { setAlert } from '../AlertSlice.js';
import './MessageBox.js';

class DashboardPoint extends FetchMixin(LitElement) {
    static get styles() {
        return css`
        :host {
            display: flex;
            flex-direction: column;
            padding: 16px;
            padding-bottom: 0;
            user-select: none;
        }

        .section {
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03);
            border: 1px solid #f3f4f6;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 100%; 
            box-sizing: border-box; 
            padding-bottom: 20px; 
            margin-bottom: 24px;
        }

        h1 {
            font-size: 1.125rem;
            font-weight: 700;
            color: #111827;
            margin: 0; /* マージンをリセット */
            text-decoration-line: none;
            white-space: nowrap; /* 折り返しを防止 */
        }

        p { margin: 5px; }
        p:last-child { margin-bottom: 10px; }

        .pp-container {
            position: relative;
            width: 100%;
            height: 150px; 
            display: flex;
            flex-direction: column;
        }

        .pp-title {
            display: flex;
            align-items: center;
            justify-content: space-between; /* 中央寄せから、左右への分散配置に変更 */
            width: 100%;
            padding: 20px 20px 10px 20px; /* パディングを調整 */
            box-sizing: border-box;
            position: relative;
        }
        
        .pp-actions {
            display: flex;
            gap: 8px; /* absoluteを解除し、gapでボタン間隔を調整 */
        }

        .pp-title button {
            font-size: 14px;
            border: none;
            border-radius: 50%;
            background-color: #f3f4f6;
            color: #4b5563;
            cursor: pointer;
            transition: all 0.2s ease;
            width: 32px;
            height: 32px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }

        .pp-title button:disabled {
            background-color: #f3f4f6;
            color: #9ca3af;
            cursor: not-allowed;
            opacity: 0.7;
        }

        .pp-title button:not(:disabled):hover {
            background-color: #e5e7eb;
            color: #111827;
        }

        .pp-point-text-container {
            display: flex;
            flex-grow: 1;
            justify-content: center;
            align-items: center; 
            position: relative;
        }

        .pp-point-text {
            display: flex;
            margin: 0 !important;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-weight: 800;
            color: #111827;
        }

        .pp-diff-text {
            position: absolute;
            font-size: 20px;
            font-weight: bold;
            opacity: 0;
            transition: transform 1s, opacity 1s;
        }

        .diff-add { color: #10b981; transform: translateY(-40px); }
        .diff-remove { color: #ef4444; transform: translateY(-20px); }

        @keyframes rotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .rotate-animation { animation: rotate 2s linear infinite; }

        .pp-button-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            margin-top: auto; 
            padding: 0 20px; 
            box-sizing: border-box;
            flex-shrink: 0;
        }

        .pp-button-wrapper {
             width: 100%;
             margin-bottom: 5px; 
        }
        .pp-status-text-container {
            height: 25px; 
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

        .pp-button {
            padding: 12px;
            font-size: 14px;
            font-weight: 600;
            border: none;
            border-radius: 8px;
            background-color: #10b981; 
            color: white;
            cursor: pointer;
            transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
            width: 100%;
            box-sizing: border-box;
            box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .pp-button .main-text {
             display: flex;
             align-items: center;
             gap: 8px;
        }

        .pp-button:disabled {
            background-color: #f3f4f6;
            color: #9ca3af;
            cursor: not-allowed;
            box-shadow: none;
        }

        .pp-button:not(:disabled):hover {
            background-color: #059669;
            transform: translateY(-1px);
            box-shadow: 0 4px 6px rgba(16, 185, 129, 0.3);
        }

        .remaining-count-text {
            font-size: 11px;
            margin-top: 4px;
            text-align: center;
            color: rgba(255,255,255,0.9);
            font-weight: normal;
        }

        .remaining-time {
            font-size: 13px;
            color: #ef4444; 
            text-align: center;
            font-weight: 600;
            line-height: 25px; 
        }

        .available-text {
            font-size: 13px;
            color: #10b981; 
            text-align: center;
            font-weight: 600;
            line-height: 25px; 
        }

        @keyframes pulse-shadow { 0%, 100% { text-shadow: 0 0 5px rgba(16, 185, 129, 0.5); } 50% { text-shadow: 0 0 15px rgba(16, 185, 129, 1); } }
        .pulse-shadow-animation { animation: pulse-shadow 2s infinite ease-in-out; }
        @keyframes shake { 0% { transform: translateX(0); } 50% { transform: translateX(5px); } 100% { transform: translateX(0); } }
        .shake-animation { animation: shake 0.5s infinite ease-in-out; display: inline-block; }
        
        .coupon-input { width: 100%; padding: 10px; margin-top: 10px; box-sizing: border-box; border: 1px solid #d1d5db; border-radius: 6px; font-size: 14px; transition: border-color 0.2s;}
        .coupon-input:focus { border-color: #3b82f6; outline: none; }
        .confirm-ok-button { color: white; background: #3b82f6; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-weight:600;}
        .confirm-ok-button:hover { background: #2563eb; }
        .confirm-cancel-button { color: #374151; background: #f3f4f6; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-weight:600;}
        .confirm-cancel-button:hover { background: #e5e7eb; }

        .modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; }
        .modal-content { background: white; padding: 24px; border-radius: 12px; width: 90%; max-width: 400px; max-height: 80vh; display: flex; flex-direction: column; box-shadow: 0 10px 25px rgba(0,0,0,0.1); animation: modal-appear 0.3s ease-out forwards; }
        @keyframes modal-appear { from { opacity: 0; transform: scale(0.9) translateY(-10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        .modal-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; }
        .modal-header h2 { margin: 0; font-size: 18px; color: #111827; font-weight:700;}
        .close-button { background: none; border: none; font-size: 24px; cursor: pointer; color: #9ca3af; transition: color 0.2s;}
        .close-button:hover { color: #4b5563; }
        
        .history-list { 
            flex-grow: 1; 
            overflow-y: auto; 
            margin-bottom: 10px; 
            padding-right:5px;
            transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s ease;
            max-height: 0;
            opacity: 0;
        }
        .history-list.expanded {
            max-height: 60vh;
            opacity: 1;
        }
        
        .history-item { 
            display: flex; 
            justify-content: space-between; 
            align-items: center; 
            padding: 12px 0; 
            border-bottom: 1px solid #f9fafb; 
            animation: item-in 0.4s ease-out forwards;
            opacity: 0;
        }
        @keyframes item-in { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .history-item:last-child { border-bottom: none;}
        .history-info { display: flex; flex-direction: column; gap:4px;}
        .history-date { font-size: 11px; color: #9ca3af; }
        .history-type { font-size: 13px; color: #374151; font-weight:500;}
        .history-points { font-size: 15px; font-weight: 700; }
        .points-plus { color: #10b981; }
        .points-minus { color: #ef4444; }
        .load-more-button { background-color: #f9fafb; border: 1px solid #e5e7eb; color: #4b5563; padding: 10px; width: 100%; cursor: pointer; border-radius: 6px; margin-top: 10px; font-weight:600; transition: background-color 0.2s;}
        .load-more-button:hover { background-color: #f3f4f6; }
        .loading-text { text-align: center; color: #9ca3af; padding: 10px; font-size: 13px;}
        .no-history { text-align: center; color: #9ca3af; padding: 20px; font-size: 14px;}
        `;
    }

    static get properties() {
        return {
            identKey: { type: String },
            pwappyPoints: { type: Number },
            _previousPwappyPoints: { type: Number },
            _pointDiff: { type: Number },
            _pendingPwappyPoints: { type: Number },
            remainingCount: { type: Number },
            remainingMaxCount: { type: Number },
            remainingCountUpdatedTime: { type: Date },
            serverTime: { type: Date },
            viewCompletedTime: { type: Date },
            viewIntervalSeconds: { type: Number },
            remainingTimeFormatted: { type: String, state: true },

            _isHistoryModalOpen: { type: Boolean, state: true },
            _historyData: { type: Array, state: true },
            _historyPage: { type: Number, state: true },
            _historyIsLoading: { type: Boolean, state: true },
            _historyHasMore: { type: Boolean, state: true },
            _historyInitialLoaded: { type: Boolean, state: true },
        };
    }

    constructor() {
        super();
        this.pwappyPoints = 0;
        this._previousPwappyPoints = 0;
        this._pointDiff = 0;
        this.identKey = null;
        this._pendingPwappyPoints = 0;
        this.pwappyPointInit = false;
        this.remainingCount = 0;
        this.remainingMaxCount = 0;
        this.remainingCountUpdatedTime = null;
        this.serverTime = null;
        this.viewCompletedTime = null;
        this.viewIntervalSeconds = 0;
        this.remainingTimeFormatted = null;
        this._timerId = null;
        this._clientTimeAtFetch = null;
        this._clientNextHourAtFetch = null;
        this._isCouponsSubmitting = false;

        this._isHistoryModalOpen = false;
        this._historyData = [];
        this._historyPage = 1;
        this._historyIsLoading = false;
        this._historyHasMore = true;
        this._historyInitialLoaded = false;

        window.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                if (!this._timerId || this.remainingTimeFormatted === "AVAILABLE") {
                    this.showPwappyPoints();
                }
            } else {
                this._stopTimer();
            }
        })
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this._stopTimer();
    }

    firstUpdated(changedProperties) {
        requestAnimationFrame(() => {
            const fontAwasomeStyle = document.querySelector("link[rel='stylesheet'][data-name='fontawesomev6']");
            if (fontAwasomeStyle) {
                const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
                fontAwasomeStyleClone.removeAttribute('disabled');
                this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);
            }
        })
    }

    formatPwappyPoints(value) {
        const num = Number(value);
        if (!isNaN(num) && Number.isInteger(num)) return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return "0";
    }

    showPwappyPoints() {
        const loginCookieName = process.env.LOGIN_COOKIE_NAME;
        const isLogin = document.cookie.split(';').some((item) => item.trim().startsWith(loginCookieName + '='));
        if (isLogin) {
            requestAnimationFrame(async () => {
                const reloadButton = this.shadowRoot.querySelector('#reload-button');
                const rotateIcon = this.shadowRoot.querySelector('#rotete-icon');
                if (reloadButton) reloadButton.disabled = true;
                if (rotateIcon) rotateIcon.classList.add('rotate-animation');

                try {
                    await this.fetchGetPwappyPoints();
                    if (this.remainingCountUpdatedTime && this.serverTime) {
                        const updatedTime = this.formatDate(this.remainingCountUpdatedTime);
                        const serverTime = this.formatDate(this.serverTime);
                        if (updatedTime !== serverTime) await this.updateRemainingCount();
                    }
                } catch (error) {
                    console.error('Error fetching pwappy point:', error);
                    this._stopTimer();
                    this.remainingTimeFormatted = null;
                } finally {
                    if (rotateIcon) rotateIcon.classList.remove('rotate-animation');
                    if (reloadButton) reloadButton.disabled = false;
                }
            })
        } else {
            this._stopTimer();
            this.remainingTimeFormatted = null;
        }
    }

    async fetchGetPwappyPoints() {
        try {
            const json = await this.fetchWithAuth(process.env.POINTS_ENDPOINT, { method: 'GET' });

            this._pendingPwappyPoints = json.details.pwappyPoints;
            this.remainingCount = json.details.remainingCount;
            this.remainingMaxCount = json.details.remainingMaxCount;

            this.remainingCountUpdatedTime = json.details.remainingCountUpdatedTime ? new Date(json.details.remainingCountUpdatedTime) : null;
            this.serverTime = json.details.serverTime ? new Date(json.details.serverTime) : null;
            this.viewCompletedTime = json.details.viewCompletedTime ? new Date(json.details.viewCompletedTime) : null;
            this.viewIntervalSeconds = json.details.viewIntervalSeconds || 0;

            this._clientTimeAtFetch = Date.now();
            const now = new Date();
            const nextHourDate = new Date(now);
            nextHourDate.setHours(now.getHours() + 1, 0, 0, 0);
            this._clientNextHourAtFetch = nextHourDate;

            pwappyPointStore.dispatch(setPwappyPoints(this._pendingPwappyPoints));

            this._pointDiff = this._pendingPwappyPoints - this._previousPwappyPoints;
            this._previousPwappyPoints = this._pendingPwappyPoints;
            if (this._pointDiff !== 0) {
                if (this.pwappyPointInit) this._showPointDiff();
                else { this.pwappyPoints = this._pendingPwappyPoints; this.pwappyPointInit = true; }
            }

            this._startTimer();
            return Promise.resolve(json);
        } catch (error) {
            console.error('Error in fetchGetPwappyPoints:', error);
            this._stopTimer();
            this.remainingTimeFormatted = null;
            return Promise.reject(error);
        }
    }

    async updateRemainingCount() {
        try {
            const response = await this.fetchWithAuth(`${process.env.ADMAX_VIEW_STATUS_ENDPOINT}/remaining-count`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) });
            this.remainingCount = response.details.remainingCount;
            this.remainingMaxCount = response.details.remainingMaxCount;
            this.remainingCountUpdatedTime = response.details.remainingCountUpdatedTime ? new Date(response.details.remainingCountUpdatedTime) : null;
            this.serverTime = response.details.serverTime ? new Date(response.details.serverTime) : null;

            this._clientTimeAtFetch = Date.now();
            this._startTimer();
        } catch (error) {
            console.error('remainingCountの更新中にエラーが発生しました:', error);
            this._stopTimer();
            this.remainingTimeFormatted = null;
        }
    }

    formatDate(date) {
        if (!date || !(date instanceof Date) || isNaN(date)) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}`;
    }

    formatHistoryDate(dateStr) {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date)) return dateStr;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}`;
    }

    async handleCouponClick(event) {
        const messageBox = this.shadowRoot.querySelector('#coupon-input-dialog');
        const inputField = this.shadowRoot.querySelector('#coupon-code-input');
        const okButton = this.shadowRoot.querySelector('.confirm-ok-button');

        inputField.value = '';
        const showPromise = messageBox.show();
        requestAnimationFrame(() => inputField.focus());

        const ret = await showPromise;
        if (ret) {
            const couponCode = inputField.value.trim();
            if (couponCode) {
                if (okButton) {
                    okButton.disabled = true;
                    okButton.textContent = '適用中...';
                    okButton.style.opacity = '0.6';
                    okButton.style.cursor = 'not-allowed';
                }
                try { await this.applyCoupon(couponCode); }
                finally {
                    if (okButton) {
                        okButton.disabled = false;
                        okButton.textContent = '適用';
                        okButton.style.opacity = '';
                        okButton.style.cursor = 'pointer';
                    }
                    messageBox.hide();
                }
            } else {
                alertStore.dispatch(setAlert('クーポンコードを入力してください'));
                messageBox.hide();
            }
        } else { messageBox.hide(); }
    }

    handleCouponInputKeydown(event) {
        if (event.key === 'Enter') {
            const okButton = this.shadowRoot.querySelector('#coupon-input-dialog .confirm-ok-button');
            if (okButton) okButton.click();
        }
    }

    async applyCoupon(couponCode) {
        if (this._isCouponsSubmitting) return;
        this._isCouponsSubmitting = true;

        try {
            const response = await this.fetchWithAuth(process.env.COUPON_ENDPOINT, { method: 'PUT', body: JSON.stringify({ couponCode: couponCode }) });
            if (response.code === 200) {
                const points = response.details.points;
                alertStore.dispatch(setAlert(`クーポンが適用されました！\n${points}ポイント獲得しました。`));
                this.showPwappyPoints();
            } else {
                alertStore.dispatch(setAlert(response.message || 'クーポンの適用に失敗しました'));
            }
        } catch (error) {
            console.error('Error applying coupon:', error);
            alertStore.dispatch(setAlert(error.message || 'エラーが発生しました'));
        } finally { this._isCouponsSubmitting = false; }
    }

    async handleHistoryClick() {
        this._isHistoryModalOpen = true;
        this._historyInitialLoaded = false;
        this._historyData = [];
        this._historyPage = 1;
        this._historyHasMore = true;

        // バツボタンにフォーカスを当てる
        // レンダリングが完了するのを待つ
        await this.updateComplete;

        // バツボタン（close-button）を取得してフォーカスを当てる
        const closeBtn = this.shadowRoot.querySelector('.close-button');
        if (closeBtn) {
            closeBtn.focus();
        }

        this._fetchHistory();
    }

    closeHistoryModal() { this._isHistoryModalOpen = false; }

    async _fetchHistory() {
        if (this._historyIsLoading) return;
        this._historyIsLoading = true;

        const limit = 20;
        const url = `${process.env.POINTS_ENDPOINT_HISTORY}?limit=${limit}&page=${this._historyPage}`;

        try {
            const response = await this.fetchWithAuth(url, { method: 'GET' });
            if (response.code === 200 && response.details && response.details.histories) {
                const newHistories = response.details.histories;
                this._historyData = [...this._historyData, ...newHistories];
                if (newHistories.length < limit) this._historyHasMore = false;
                else this._historyPage++;
            } else { this._historyHasMore = false; }
        } catch (error) {
            console.error('Error fetching history:', error);
            alertStore.dispatch(setAlert('履歴の取得に失敗しました'));
        } finally {
            this._historyIsLoading = false;
            this._historyInitialLoaded = true;
        }
    }

    _translateTransactionType(type) {
        const map = {
            'Acquisition_by_Purchase': 'ポイント購入',
            'Acquisition_by_Viewing_Advertisements': '動画広告視聴',
            'Use_by_Service_Contract': 'サービス利用',
            'Use_by_AI_Coding': 'AIコーディング',
            'Acquisition_by_Advertisements': '広告視聴(画像)',
            'Use_by_Download': '公開ファイルDL',
            'Acquisition_by_Referral': '紹介ボーナス',
            'Use_by_App_Archive': 'アプリアーカイブ',
            'Use_by_App_Restore': 'アプリ復元',
            'Use_by_Daily_Report': '日次維持費',
            'Refund_by_Moderation_Timeout': '審査ポイント返還',
            'Acquisition_by_New_Registration': '新規登録ボーナス',
            'Admin_Adjustment': '管理者調整',
            'Acquisition_by_Coupon': 'クーポン適用'
        };
        return map[type] || type;
    }

    _showPointDiff() {
        const diffText = document.createElement('div');
        diffText.classList.add('pp-diff-text');
        diffText.textContent = `${this._pointDiff > 0 ? '+' : ''}${this.formatPwappyPoints(this._pointDiff)}`;
        diffText.classList.add(this._pointDiff > 0 ? 'diff-add' : 'diff-remove');

        const container = this.shadowRoot.querySelector('.pp-point-text-container');
        if (container) {
            container.appendChild(diffText);
            requestAnimationFrame(() => { diffText.style.opacity = '1'; });
            setTimeout(() => {
                diffText.style.opacity = '0';
                diffText.style.transform = this._pointDiff > 0 ? 'translateY(-20px)' : 'translateY(-40px)';
                diffText.addEventListener('transitionend', () => {
                    diffText.remove();
                    this.pwappyPoints = this._pendingPwappyPoints;
                });
            }, 1000);
        }
    }

    _startTimer() {
        this._stopTimer();
        if (this.viewCompletedTime instanceof Date && !isNaN(this.viewCompletedTime) &&
            this.viewIntervalSeconds > 0 &&
            this.serverTime instanceof Date && !isNaN(this.serverTime) &&
            this._clientTimeAtFetch) {
            this._updateRemainingTime();
            if (this.remainingTimeFormatted !== "AVAILABLE") {
                this._timerId = setInterval(() => { this._updateRemainingTime(); }, 1000);
            }
        } else {
            if (this.remainingTimeFormatted !== null) this.remainingTimeFormatted = null;
        }
    }

    _stopTimer() {
        if (this._timerId) { clearInterval(this._timerId); this._timerId = null; }
    }

    _updateRemainingTime() {
        if (!this.viewCompletedTime || !(this.viewCompletedTime instanceof Date) || isNaN(this.viewCompletedTime) ||
            !this.serverTime || !(this.serverTime instanceof Date) || isNaN(this.serverTime) ||
            !this._clientTimeAtFetch || this.viewIntervalSeconds <= 0) {
            if (this.remainingTimeFormatted !== null) this.remainingTimeFormatted = null;
            this._stopTimer();
            return;
        }

        try {
            const nextViewAvailableTimeMs = this.viewCompletedTime.getTime() + this.viewIntervalSeconds * 1000;
            const elapsedClientTimeMs = Date.now() - this._clientTimeAtFetch;
            const estimatedServerNowMs = this.serverTime.getTime() + elapsedClientTimeMs;
            const remainingMilliseconds = nextViewAvailableTimeMs - estimatedServerNowMs;
            const remainingSeconds = Math.max(0, Math.floor(remainingMilliseconds / 1000));

            if (this.remainingCount === 0) {
                const elapsedClientTimeMs = Date.now() - this._clientTimeAtFetch;
                const estimatedServerNowMs = this.serverTime.getTime() + elapsedClientTimeMs;
                const now = new Date(estimatedServerNowMs);
                const nextHourDate = this._clientNextHourAtFetch;
                const remainingTimeMs = nextHourDate.getTime() - now.getTime();
                const remainingSeconds = Math.floor(remainingTimeMs / 1000);

                if (remainingTimeMs >= 0) {
                    const minutes = Math.floor(remainingSeconds / 60);
                    const seconds = remainingSeconds % 60;
                    const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                    if (this.remainingTimeFormatted !== formattedTime) this.remainingTimeFormatted = formattedTime;
                } else {
                    this._stopTimer();
                    this.showPwappyPoints();
                }
            } else {
                if (remainingSeconds <= 0) {
                    if (this.remainingTimeFormatted !== "AVAILABLE") this.remainingTimeFormatted = "AVAILABLE";
                    this._stopTimer();
                } else {
                    const minutes = Math.floor(remainingSeconds / 60);
                    const seconds = remainingSeconds % 60;
                    const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                    if (this.remainingTimeFormatted !== formattedTime) this.remainingTimeFormatted = formattedTime;
                }
            }
        } catch (e) {
            console.error("Error calculating remaining time:", e);
            if (this.remainingTimeFormatted !== null) this.remainingTimeFormatted = null;
            this._stopTimer();
        }
    }

    _renderStatusText() {
        if (this.remainingCount === 0) {
            if (this.serverTime) return html`<p class="remaining-time">更新まで：${this.remainingTimeFormatted}</p>`;
            else return html`<p class="remaining-time">しばらくお待ちください</p>`;
        } else if (this.remainingTimeFormatted === "AVAILABLE") {
            return html`<p class="available-text shake-animation">ポイント取得可能</p>`;
        } else if (this.remainingTimeFormatted) {
            return html`<p class="remaining-time">次の視聴まで: ${this.remainingTimeFormatted}</p>`;
        } else { return html``; }
    }

    initPointData(pointInfo) {
        this._pendingPwappyPoints = pointInfo.pwappyPoints;
        this.remainingCount = pointInfo.remainingCount;
        this.remainingMaxCount = pointInfo.remainingMaxCount;
        this.remainingCountUpdatedTime = pointInfo.remainingCountUpdatedTime ? new Date(pointInfo.remainingCountUpdatedTime) : null;
        this.serverTime = pointInfo.serverTime ? new Date(pointInfo.serverTime) : null;
        this.viewCompletedTime = pointInfo.viewCompletedTime ? new Date(pointInfo.viewCompletedTime) : null;
        this.viewIntervalSeconds = pointInfo.viewIntervalSeconds || 0;

        this._clientTimeAtFetch = Date.now();
        const now = new Date();
        const nextHourDate = new Date(now);
        nextHourDate.setHours(now.getHours() + 1, 0, 0, 0);
        this._clientNextHourAtFetch = nextHourDate;

        pwappyPointStore.dispatch(setPwappyPoints(this._pendingPwappyPoints));

        this._pointDiff = this._pendingPwappyPoints - this._previousPwappyPoints;
        this._previousPwappyPoints = this._pendingPwappyPoints;
        if (this._pointDiff !== 0) {
            if (this.pwappyPointInit) this._showPointDiff();
            else { this.pwappyPoints = this._pendingPwappyPoints; this.pwappyPointInit = true; }
        }
        this._startTimer();
    }

    render() {
        return html`
            <div style="position:relative; height: 100%;">
                <message-box id="coupon-input-dialog">
                    <div slot="message-slot">
                        <p style="text-align: center; font-weight:bold; color:#374151;">クーポンコードを入力してください</p>
                        <input type="text" id="coupon-code-input" class="coupon-input" placeholder="クーポンコード" @keydown="${this.handleCouponInputKeydown}">
                    </div>
                    <button slot="ok-slot" class="confirm-ok-button">適用</button>
                    <button slot="cancel-slot" class="confirm-cancel-button">キャンセル</button>
                </message-box>

                ${this._isHistoryModalOpen ? html`
                <div class="modal-overlay" @click="${(e) => { if (e.target === e.currentTarget) this.closeHistoryModal(); }}">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2>ポイント履歴</h2>
                            <button class="close-button" @click="${this.closeHistoryModal}">&times;</button>
                        </div>
                        <div class="history-list ${this._historyInitialLoaded ? 'expanded' : ''}">
                            ${this._historyData.length === 0 && !this._historyIsLoading ? html`<p class="no-history">履歴がありません</p>` : ''}
                            ${this._historyData.map((item, index) => html`
                                <div class="history-item" style="animation-delay: ${index * 0.03}s">
                                    <div class="history-info">
                                        <span class="history-type">${this._translateTransactionType(item.transactionType)}</span>
                                        <span class="history-date">${this.formatHistoryDate(item.createdDate)}</span>
                                    </div>
                                    <div class="history-points ${item.points > 0 ? 'points-plus' : 'points-minus'}">
                                        ${item.points > 0 ? '+' : ''}${this.formatPwappyPoints(item.points)}
                                    </div>
                                </div>
                            `)}
                            ${this._historyIsLoading ? html`<div class="loading-text">読み込み中...</div>` : ''}
                        </div>
                        ${this._historyHasMore && !this._historyIsLoading && this._historyInitialLoaded ? html`<button class="load-more-button" @click="${this._fetchHistory}">もっと見る</button>` : ''}
                    </div>
                </div>
                ` : ''}

                <div class="section">
                    <div class="pp-title">
                        <h1>ポイント</h1>
                        <div class="pp-actions">
                            <button id="reload-button" @click="${this.showPwappyPoints}" title="更新">
                                <i id="rotete-icon" class="fa-solid fa-rotate"></i>
                            </button>
                            <button id="coupon-button" @click="${this.handleCouponClick}" title="クーポン入力">
                                <i class="fa-solid fa-ticket"></i>
                            </button>
                            <button id="history-button" @click="${this.handleHistoryClick}" title="ポイント履歴">
                                <i class="fa-solid fa-clock-rotate-left"></i>
                            </button>
                        </div>
                    </div>
                    <div class="pp-container">
                        <div class="pp-point-text-container">
                            <p class="pp-point-text">${this.formatPwappyPoints(this.pwappyPoints)} PP</p>
                        </div>
                        <div class="pp-button-container">
                             <div class="pp-button-wrapper">
                                <a href="/admax_view.html" target="_blank" rel="noopener noreferrer" style="width: 100%; display: block; text-decoration:none;">
                                    <button class="pp-button">
                                        <div class="main-text"><i class="fa-solid fa-ad"></i>広告視聴</div>
                                        <div class="remaining-count-text">取得可能回数：∞</div>
                                    </button>
                                </a>
                            </div>
                            <div class="pp-status-text-container">
                                ${this._renderStatusText()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('dashboard-point', DashboardPoint);